import type { ReceiptTemplate } from '../schema';

export const dollarGeneralTemplate: ReceiptTemplate = {
  id: 'dollar-general',
  name: 'Dollar General Receipt',
  brand: 'DOLLAR GENERAL',
  description: 'Discount retail store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'dg-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 160,
        logoHeight: 50,
        businessName: 'DOLLAR GENERAL',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #12847',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dg-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'STR 12847  REG 02  TRN 8472\n01/04/26 14:23  CASHIER: MIKE',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'dg-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'dg-item-1', name: 'PAPER TOWELS', quantity: '1', price: '4.50'},
          { id: 'dg-item-2', name: 'DISH SOAP', quantity: '1', price: '3.00'},
          { id: 'dg-item-3', name: 'SNACK CHIPS', quantity: '2', price: '2.50'},
          { id: 'dg-item-4', name: 'CANDY BAR', quantity: '3', price: '1.25'},
          { id: 'dg-item-5', name: 'BATTERIES AA 4PK', quantity: '1', price: '5.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'dg-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'dg-subtotal', label: 'SUBTOTAL', value: '22.25', isBold: false, isLarge: false },
          { id: 'dg-tax', label: 'TAX', value: '1.97', isBold: false, isLarge: false },
          { id: 'dg-total', label: 'TOTAL', value: '24.22', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'dg-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'dg-card', label: 'DEBIT', value: '************4144' },
          { id: 'dg-auth', label: 'AUTH', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'dg-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '128478472010426',
        showValue: true,
        width: 1.5,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'dg-survey',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'SAVE EVEN MORE!\nTELL US AT DGCUSTOMERFIRST.COM\nWIN $100 DG GIFT CARD',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

